<template>
  <el-dialog
    :title="`退货明细(${outInfo.goodsReturnCode})`"
    :visible.sync="visible"
    width="600px"
    append-to-body
    @closed="handleClosed"
  >
    <el-table
      v-loading="loading"
      border
      :data="outInfo.goodsReturnItems">
      <el-table-column
        label="商品名称"
        prop="productName"></el-table-column>
      <el-table-column
        label="退货数量"
        width="100"
        prop="returnGoodsCount"></el-table-column>
    </el-table>
    <div slot="footer">
      <!-- <el-button
        type="primary"
        :loading="loading"
        @click="agreereturn">同意退货</el-button> -->
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'DetailModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      outInfo: {},
      visible: false,
      config: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    agreereturn() {
      this.$confirm('是否同意退货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('goodsreturn/submitgoodsreturn', {
          payload: {
            draftGoodsReturnId: this.config.goodsReturnId
          },
          success: () => {
            this.loading = false
            this.toggleModal(false)
            this.callback && this.callback()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleClosed() {
      this.outInfo = {}
      this.config = {}
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('goodsreturn/getgoodsreturn', {
        payload: {
          ...this.config,
          vendorId: this.userInfo.orgId
        },
        success: res => {
          this.loading = false
          this.outInfo = res.data
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.config.goodsReturnId = row.goodsReturnId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
